var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrap"},[_vm._v(" 邯郸工业设计中心有限公司 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }